import React from 'react';

export const {
  Provider: ComponentNameProvider,
  Consumer,
} = React.createContext(null);

export const withComponentName = Component => props => (
  <Consumer>{name => <Component {...props} componentName={name} />}</Consumer>
);
